import { useEntityForm } from '@/shared/lib'

import {
  userNoteSchema,
  userNoteFormInitial,
  buildCreateUserNotePayload,
  type UserNoteForm,
  type CreateUserNotePayload
} from '@/apps/adok/entities/user-note'

export function useUserNoteCreateForm() {
  return useEntityForm<UserNoteForm, CreateUserNotePayload>({
    schema: userNoteSchema,
    initial: userNoteFormInitial,
    buildPayload: buildCreateUserNotePayload
  })
}
